import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

function Header() {
  const navigate = useNavigate();
  const { getCartCount } = useCart();
  const cartCount = getCartCount();

  const scrollToSearch = () => {
    // Navigate to home page first
    navigate('/');
    // Wait for navigation then scroll to search
    setTimeout(() => {
      const searchInput = document.querySelector('input[placeholder*="Search"]');
      if (searchInput) {
        searchInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        searchInput.focus();
      }
    }, 100);
  };

  return (
    <header className="fixed top-0 w-full z-50 px-6 py-4 flex items-center justify-between bg-[#020403]/80 backdrop-blur-md border-b border-white/10">
      <div className="flex items-center gap-3">
        <span className="material-symbols-outlined text-green-500 text-3xl animate-pulse">token</span>
        <Link to="/" className="text-white text-xl font-bold tracking-widest uppercase hover:text-green-500 transition-colors" style={{fontFamily: 'Space Grotesk, sans-serif'}}>
          StreetMoneyGaming
        </Link>
      </div>

      <div className="hidden md:flex gap-8 text-sm tracking-widest text-gray-400">
        <Link className="hover:text-blue-400 transition-colors hover:shadow-[0_0_10px_rgba(0,243,255,0.5)]" to="/">
          [ MARKETPLACE ]
        </Link>
        <Link className="hover:text-blue-400 transition-colors hover:shadow-[0_0_10px_rgba(0,243,255,0.5)]" to="/StreetPay">
          [ StreetPay ]
        </Link>
      </div>

      <div className="flex gap-4">
        <button
          onClick={scrollToSearch}
          className="text-white hover:text-green-500 transition-colors"
          title="Search products"
        >
          <span className="material-symbols-outlined">search</span>
        </button>
        <Link to="/cart" className="text-white hover:text-green-500 transition-colors relative" title="View cart">
          <span className="material-symbols-outlined">shopping_cart</span>
          {cartCount > 0 && (
            <span className="absolute -top-2 -right-2 bg-green-500 text-black text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center font-mono">
              {cartCount}
            </span>
          )}
        </Link>
      </div>
    </header>
  );
}

export default Header;
